// AI Organization Settings Types
export const BYO_AI_PROVIDERS = [
    'anthropic',
    'google',
    'openai',
    'bedrock',
];
// Providers whose org credential is a bare API key string. Bedrock is excluded:
// it also needs a region, so it carries a config object instead.
export const BYO_AI_API_KEY_PROVIDERS = [
    'anthropic',
    'google',
    'openai',
];
export const isByoAiProvider = (provider) => BYO_AI_PROVIDERS.includes(provider);
// Regions where Bedrock accepts API-key authentication and we can route Claude
// to an in-region or same-geography inference profile.
export const BEDROCK_REGIONS = [
    'ap-northeast-1',
    'ap-northeast-3',
    'us-east-1',
    'us-west-2',
];
//# sourceMappingURL=adminTypes.js.map